import React from "react";

import { Avatar, Divider, Stack, Typography } from "@mui/material";

import { NewsComment } from "./types";

interface Props {
  comment: NewsComment;
}

export const CommentHeader: React.FC<Props> = ({ comment }) => {
  return (
    <Stack direction="row" gap="10px" alignItems="flex-start">
      <Avatar
        src={comment.user.avatarUrl}
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          flexShrink: 0
        }}
      />
      <Stack flex={1} gap="2px">
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#000000",
            lineHeight: "20px"
          }}
        >
          {comment.user.name}
        </Typography>
        <Stack direction="row" gap="5px" alignItems="center">
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#496682",
              lineHeight: "16px"
            }}
          >
            {comment.user.role}
          </Typography>
          <Divider orientation="vertical" flexItem sx={{ height: "16px", borderColor: "#dbe8f5" }} />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#071f35",
              lineHeight: "16px"
            }}
          >
            {comment.timeAgo}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

